module.exports = __webpack_public_path__ + "img/Quadcept_Home_0.da6a9709.png";